import { IconShieldCheck } from '@/components/Icons'
import { cn } from '@/lib/utils'

export function TrustNotes({ items, className }: { items: string[]; className?: string }) {
  return (
    <ul
      className={cn(
        'flex flex-wrap gap-x-6 gap-y-2 text-[13px] text-[var(--surface-muted)]',
        className,
      )}
    >
      {items.map((item) => (
        <li key={item} className="inline-flex items-center gap-2">
          <IconShieldCheck size={15} aria-hidden="true" className="shrink-0 text-green-400" />
          {item}
        </li>
      ))}
    </ul>
  )
}
